module.exports = __webpack_public_path__ + "static/media/21ECLAC13.92c9194e.jpg";